import { Action, Reducer } from 'redux';
import {
  MappingTypeState,
  MappingTypeTypes,
  MappingTypeActionTypes
} from './mappingTypeTypes';

export const INITIAL_STATE: MappingTypeState = {
  mappingType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const mappingTypeReducer: Reducer<MappingTypeState> = (
  state: MappingTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as MappingTypeActionTypes;
  switch (actionTypes.type) {
    case MappingTypeTypes.GET_MAPPING_TYPE:
      return {
        ...state,
        mappingType: { ...state.mappingType, isLoading: true }
      };
    case MappingTypeTypes.SAVE_MAPPING_TYPE:
      return {
        ...state,
        mappingType: {
          ...state.mappingType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case MappingTypeTypes.RESET_REDUCER_MAPPING_TYPE:
      return {
        ...state,
        mappingType: INITIAL_STATE.mappingType
      };
    default:
      return state;
  }
};

export default mappingTypeReducer;

